<template>
    <v-expansion-panel @animationend="animated = false" :readonly=readonly>
        <v-expansion-panel-header
            class="pa-2"
            :hide-actions="item.product && (item.product.type == 'trainingcard' || item.product.type == 'membership')"
        >
            <div class="d-flex flex-column animate__animated animate__bounceIn" :key="item.count">
                <div class="d-flex align-center">
                    <v-avatar color="primary" size="32" class="mr-2" >
                        <v-auto-img v-if="item.imagekey" :src="item.imagekey ? item.imagekey : undefined" height="32" width="32" />
                        <span v-if="!item.imagekey" class="white--text">{{item.name.substr(0,1)}}</span>
                    </v-avatar>
                    <div class="flex-grow-1"><span v-if="item.count != 1 && !item.product_id">{{item.count }}&nbsp;x&nbsp;</span>{{item.name}}<span v-if="item.variant">, {{item.variant}}</span></div>
                    <div class="mr-6 text-no-wrap" v-if="showProductCount">
                        <product-count  @input="attemptChangeNumberOfItems(item, $event)" :value="item.count" :disabled="countReadOnly" />
                    </div>
                    <div class="mr-2 text-no-wrap" v-else-if="showRemoveButton">
                        <v-btn small icon @click="removeItem(item)"><v-icon >mdi-trash-can-outline</v-icon></v-btn>
                    </div>
                    <div v-if="hasPayment" class="text-no-wrap font-weight-bold" style="{width: 3.56rem}" :class="{'red--text': item.total < 0, 'primary--text': item.total > 0, 'mr-6': readonly}">{{item.total | price}}</div>
                </div>

                <div v-if="item.product_id && totalFromServerObject && totalFromServerObject.subscriptions_pay_now && totalFromServerObject.subscriptions_pay_now[item.product_id]" style="margin-left: 40px">
                    {{$translate('Partial perdiod')}} {{Date.newFull(totalFromServerObject.subscriptions_pay_now[item.product_id].from_date).daysUntil(totalFromServerObject.subscriptions_pay_now[item.product_id].to_date)}} {{$translate('days')}} {{Date.dateToDateString(totalFromServerObject.subscriptions_pay_now[item.product_id].from_date, totalFromServerObject.subscriptions_pay_now[item.product_id].to_date)}}: {{totalFromServerObject.subscriptions_pay_now[item.product_id].amount | price}}
                </div>

                <div v-if="item.product && (item.product.type == 'trainingcard' || item.product.type == 'membership')" class="mt-2" style="margin-left: 40px">
                    <template v-if="$store.state.user && !userReadOnly">
                        <div v-for="c in item.count" :key="c">
                            <template>
                                <h4>{{$translate('The card is valid from')}} {{ startDates[c-1] }}</h4>
                                <DateField :label="$translate('Select the start date of the card')" :min="minStartDate.yyyymmdd()" :max="maxStartDate.yyyymmdd()" v-model="item.start_dates[c-1]" v-if="item.product.customer_can_select_start_date && !hasCardsOfType(c-1)" />
                            </template>
                            <h4 class="mt-2">{{item.count == 1 ? $translate('I buy this product for') : $translate('I buy the {0} product for').format(getOrder(c))}}
                                <v-icon small :color="item.users[c-1] ? 'success' : 'error'">{{item.users[c-1] ? 'mdi-check' : 'mdi-star'}}</v-icon>
                            </h4>
                            <v-radio-group v-model="item.users[c-1]" class="mb-0 pb-0" @change="updateStartDate(c-1)">
                                <v-radio v-for="user in canBuyFor" :key="user.id" :label="user.name" :value="user.id" color="primary">
                                    <template #label>
                                        <zoezi-user-avatar :user="user" :size="28"/>
                                        <span :class="{'primary--text': item.users[c-1] == user.id}">{{user.name}}</span>
                                    </template>
                                </v-radio>
                            </v-radio-group>

                            <v-btn text color="primary" class="zoezi-button-thin" @click="addUser(item, c-1)"><v-icon color="primary" class="mr-1">mdi-plus-circle</v-icon>{{$translate('Add new person')}}</v-btn>
                        </div>
                    </template>
                    <p v-else-if="!$store.state.user && item.count > 1" class="error--text">
                        {{$translate('Identify yourself first in order to then be able to choose who should receive the products')}}
                    </p>
                </div>

                <div v-else-if="item.user_id && canBuyFor.find(cb => cb.id == item.user_id && item.user_id != $store.state.user.id)" class="mt-2" style="margin-left: 40px">
                    {{canBuyFor.find(cb => cb.id == item.user_id).name}}
                </div>
                <div v-else-if="item.users && item.users.length" class="mt-2" style="margin-left: 40px">
                    <div v-for="user in item.users.map(user_id => canBuyFor.find(cb => cb.id == user_id && user_id != $store.state.user.id)).filter(x => x)" :key="user.id">
                        {{user.name}}<br>
                    </div>
                </div>
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-2">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <template v-if="item.type == 'giftcard'">
                        <div>{{$translate('Remaining after purchase')}}: {{item.left | price}}</div>
                        <div>{{$translate('Valid to')}}: {{item.card.validToDate}}</div>
                    </template>
                    <template v-else-if="item.type == 'discount'">
                        <div v-if="item.percent">{{item.percent}} % {{$translate('discount')}}</div>
                        <div v-if="item.fixed">{{item.fixed | price}} {{$translate('deduction')}}</div>
                    </template>
                    <template v-else-if="item.type == 'valuecard'">
                        <div v-if="valueCardCannotBeUsed">
                            <template v-if="itemsContainPeriodicCards">
                                {{$translate('Value cards cannot be used to pay for a product with split payment.')}}
                            </template>
                            <template v-else>
                                {{$translate('You have a value card that does not cover the entire cost. Unfortunately, it cannot be used on this purchase as value cards cannot be used on a partial amount in combination with available payment methods.')}}
                            </template>
                        </div>
                        <div>{{$translate('Remaining after purchase')}}: {{item.left | price}}</div>
                    </template>
                    <template v-else-if="item.type == 'resourcebooking'">
                        <div v-for="(slot,index) in item.slots" :key="index" class="mb-2">
                            <resource-booking-checkout-item :service="item.service" :start="slot.start" :staff="item.service.staffs.find(s => s.id == slot.staff_id)" :optional-resources="slot.optional_resources" />
                        </div>
                    </template>
                    <template v-else-if="item.type == 'punchcard'">
                        <div v-if="item.card.validToDate">{{$translate('Valid to')}}: {{Date.newFull(item.card.validToDate).yyyymmdd()}}</div>
                        <div v-else>{{$translate('Subscription card')}}</div>
                        <div>{{$translate('Punches remaining after purchase')}}: {{item.leftAfterPurchase}}</div>
                    </template>
                    <template v-else-if="item.type == 'product'">
                        <div v-if="item.count > 1">
                            {{$translate('Count')}}: {{item.count}}<br>
                            {{$translate('Price per unit')}}: {{item.price | price}}<br><br>
                        </div>

                        <div
                            v-if="item.product.description"
                            v-html="item.product.description"
                            :style="{
                                maxWidth: summaryWidth + 'px',
                                overflowX: 'clip',
                                overflowY: 'scroll',
                                maxHeight: '200px'
                            }"
                        />
                        <div v-else>
                            {{$translate('There is no further description of the product.')}}
                        </div>
                    </template>
                    <template v-else-if="item.type == 'workoutbooking'">
                        <slot name="workoutbooking" :item="item" />
                    </template>
                    <template v-else-if="item.type == 'payment'">
                        <div v-for="(payment,pindex) in item.payments" :key="pindex">
                            {{payment.name}}<br>
                            {{$translate('Amount')}}: {{payment.amount | price}}<br>
                            <span :class="{'error--text': Date.newFull(payment.date).isPastDate()}">{{$translate('Due date')}}: {{Date.newFull(payment.date).yyyymmdd()}}</span>
                        </div>
                    </template>
                </div>
                <v-btn small icon @click="removeItem(item)" v-if="item.type == 'giftcard' || item.type == 'valuecard' || item.type == 'discount'"><v-icon >mdi-close</v-icon></v-btn>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import ResourceBookingCheckoutItem from './ResourceBookingCheckoutItem.vue'
import ProductCount from './ProductCount.vue'
import ZoeziUserAvatar from './UserAvatar.vue'
import DateField from './DateField.vue'

export default {
    name: 'zoezi-checkout-item-row',
    props: ['item', 'totalFromServerObject', 'userReadOnly', 'valueCardCannotBeUsed', 'itemsContainPeriodicCards', 'countReadOnly', 'summaryWidth'],
    components: {
        ResourceBookingCheckoutItem,
        ProductCount,
        ZoeziUserAvatar,
        DateField
    },
    computed: {
        readonly() {
            return this.item && this.item.product && (this.item.product.type == 'trainingcard' || this.item.product.type == 'membership');
        },
        hasPayment() {
            return !!this.$store.state.settings?.modules?.Payment;
        },
        canBuyFor() {
            if (!this.$store.state.user) {
                return [];
            }

            return this.$store.state.user.canBookFor.map(x => ({
                id: x.id,
                name: x.id == this.$store.state.user.id ? this.$translate('Myself') : x.name,
                imagekey: x.imagekey
            }))
        },
        showProductCount() {
            return this.item.product && this.item.product.type != 'course' && this.item.product.type != 'valuecard';
        },
        showRemoveButton() {
            return !this.showProductCount && this.item.fromCart;
        },
        minStartDate() {
            if (this.item.product.customer_can_select_start_date) {
                let startDate = this.item.product.fixed_start_date ? Date.newFull(this.item.product.earliest_start_date) : Date.today();
                if (startDate.isPastDate()) {
                    startDate = Date.today();
                }
                return startDate;
            }

            return Date.today();
        },
        maxStartDate() {
            if (this.item.product.customer_can_select_start_date) {
                let startDate = this.item.product.fixed_start_date ? Date.newFull(this.item.product.earliest_start_date) : Date.today();
                if (startDate.isPastDate()) {
                    startDate = Date.today();
                }
                const days = this.item.product.customer_select_start_date_within;
                return startDate.addDays(days);
            }

            return Date.today();
        },
        startDates() {
            if (this.item.product.customer_can_select_start_date) {
                return this.item.start_dates; // Use the existing dates if the user can change them
            }

            // Dynamically recalculate the dates if the user cannot change them
            return this.item.start_dates.map((startDate, index) => {
                return this.$booking.getStartDateForCard(
                    this.item.product,
                    this.item.users[index]
                ).yyyymmdd();
            });
        }
    },
    methods: {
        attemptChangeNumberOfItems(item, event) {
            this.$emit('attemptChangeNumberOfItems', item, event);
        },
        getOrder(c) {
            const keys = {
                1: 'first',
                2: 'second',
                3: 'third',
                4: 'fourth',
                5: 'fifth',
                6: 'sixth',
                7: 'seventh',
                8: 'eighth',
                9: 'ninth'
            };

            if (c < 10) {
                return this.$translate(keys[c]);
            } else {
                return c;
            }
        },
        addUser(item, index) {
            this.$store.commit('showAddUserDialog', {
                title: this.$translate('Add new person'),
                callback: (user) => {
                    let users = item.users.concat();
                    users[index] = user.id;
                    this.$emit('changeItemUsers', item, users);
                    // Update start date after the user is added
                    this.$nextTick(() => {
                        this.updateStartDate(index);
                    });
                }})
        },
        removeItem(item) {
            this.$emit('removeItem', item);
        },
        updateStartDate(index) {
            if (this.item.product && ['trainingcard', 'membership'].includes(this.item.product.type)) {
                const basketCards = this.item.start_dates.map((startDate, i) => ({
                    user_id: this.item.users[i],
                    cardtype_id: this.item.product.id,
                    validToDate: startDate ? this.$booking.getEndDateForCard(startDate, this.item.product) : null,
                    trainingsLeft: null
                })).filter((_, i) => i !== index);

                this.$set(
                    this.item.start_dates,
                    index,
                    this.$booking.getStartDateForCard(
                        this.item.product,
                        this.item.users[index],
                        basketCards
                    ).yyyymmdd()
                );
            }
        },
        hasCardsOfType(index) {
            // Checks if user has cards of this type, either already bought or in the basket
            const user_id = this.item.users[index];
            const userCards = this.$store.state.cards?.filter(card => card.cardtype_id == this.item.product.id && card.user_id == user_id) || [];
            const hasBasketCards = this.item.start_dates.filter((_, i) => i < index && this.item.users[i] == user_id).length > 0;
            return userCards.length > 0 || hasBasketCards;
        }
    }
}
</script>
